export default "__VITE_ASSET__NiX885z3__"